import { estClient } from './estClient';
import { JsonParseError } from './httpClient';

export interface Activity {
  id: string;
  /**
   * @example '2023-05-14 17:37:26'
   */
  created_at: string;
  /**
   * @example '2023-05-14 17:37:26'
   */
  updated_at: string;
  created_by: string;
  lead_id: string;
  unit_id: string | null;
  deal_id: string | null;
  type: string;
  value: '0';

  /**
   * Message may contain HTML
   */
  message: string;

  /**
   * How much time is left for this activity item to be allowed to be edited
   */
  secondsLeftToEdit: number;

  is_deleted: '0' | '1';

  icon: 'history-note';

  author: {
    name: string;

    /**
     * @example 'demo-ru/user/3/376a71963356b6c218fa7dbe4ab3602b.jpg'
     */
    image: string;
  };
}

export interface NoteProps {
  for_id: string;
  type: 'unit_id' | 'lead_id';
  message: string;
}

export interface NoteResponse {
  id: string;
  type: string;
  value: '0';
  is_deleted: '1' | '0';

  lead_id: string | null;
  unit_id: string | null;
  deal_id: string | null;
  message: string;
  icon: string;

  /**
   * @example "2025-04-20 22:49:19"
   */
  created_at: string;

  /**
   * @example "2025-04-20 22:49:19"
   */
  updated_at: string;
  created_by: string;

  author: {
    name: string;
    image: string;
  };
}

class ActivityApi {
  async getUnitActivity(unitId: string): Promise<Activity[]> {
    return estClient.get<Activity[]>(`/api/activity/unit/${unitId}`);
  }

  async getLeadActivity(leadId: string): Promise<Activity[]> {
    return estClient.get<Activity[]>(`/api/activity/lead/${leadId}`);
  }

  async createNote(note: NoteProps): Promise<NoteResponse> {
    return estClient.post<NoteResponse>('/api/activity/create_note', {
      body: note,
    });
  }

  async updateNote({
    id,
    ...body
  }: {
    id: string;
    message: string;
  }): Promise<NoteResponse> {
    return estClient.post<NoteResponse>(`/api/activity/${id}`, {
      body,
    });
  }

  async createNoteBulk(note: {
    type: 'lead_id' | 'unit_id';
    message: string;
    query: string;
  }) {
    try {
      await estClient.post('/api/activity/bulk_notes', {
        body: note,
      });
    } catch (error) {
      if (error instanceof JsonParseError) {
        if (error.statusCode === 200 && !error.body) {
          // it's a valid response for current action
          return;
        }
      }

      throw error;
    }
  }

  async getCallUrl(id: string): Promise<{ url: string }> {
    return estClient.get<{ url: string }>(`/api/binotel/call_url/${id}`);
  }
}

export const activityApi = new ActivityApi();
